import AddPlaylistOutline from './AddPlaylistOutline'

export default AddPlaylistOutline
// eslint-disable-next-line import/export
export * from './AddPlaylistOutline'
